function Header() {
    return (
        <header className="header">

            <div className="logo">
                <a href="/">
                    <img
                        src="/Fotos/logo_irj.png"
                        alt="IRJ Logo"
                    />
                </a>
            </div>

            <div className="werbung">
                <p>
                    <b>Ivan Jörg</b>
                    <br />
                    Persönliche Webseite
                </p>
            </div>

        </header>
    );
}

export default Header;